import * as React from 'react';
import { cn } from '@/lib/utils';

interface EmptyStateProps {
    icon: React.ReactNode;
    title: string;
    description: string;
    action?: React.ReactNode;
    className?: string;
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
    return (
        <div className={cn("flex flex-col items-center justify-center py-16 px-4 text-center", className)}>
            <div className="rounded-full bg-muted p-4 mb-4">
                {React.isValidElement(icon) && React.cloneElement(icon as React.ReactElement<{ className?: string }>, {
                    className: cn('h-8 w-8 text-muted-foreground', (icon as React.ReactElement<{ className?: string }>).props.className),
                })}
            </div>
            <h3 className="text-lg font-semibold mb-1">{title}</h3>
            <p className="text-sm text-muted-foreground max-w-sm">{description}</p>
            {action && <div className="mt-4">{action}</div>}
        </div>
    );
}
